import React, { useState } from "react";
import styled from "styled-components";
import { ModuleBase, SecondaryButton, ButtonSizeOptions } from "@loanbossinc/component-library";

import GeneralLayout from "../components/GeneralLayout";
import DripCampaignModal from "../components/DripCampaignModal";

import DealSelector from "./DealSelector";
import TemplateCreator from "./TemplateCreator";

const style = `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px;
  margin-bottom: 24px;
  margin-top: 0 !important;

  .title {
    display: flex;
    flex: 1;
    font-family: Work Sans;
    color: #000000;
    font-weight: 500;
    font-size: 24px;
  }
`;

const StyledCard = styled(ModuleBase)`
  && {
    ${style}
    width: 100%;
  }
`;

const StyledTitle = styled.div`${style}`;

const StyledLabel = styled.div`
  font-weight: 500;
  font-size: 24px;
  margin: 16px 0;
`;

const StyledModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 440px;
`;

const StyledModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const campaigns = [
  "Refi Cash Out",
  "Refi Breakeven",
  "Prepayment"
];

export const Campaigns = () => {
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedDeal, setSelectedDeal] = useState(null);
  const [templateShown, setTemplateShown] = useState(false);

  const handleDealSelection = deal => {
    setSelectedDeal(deal);
  };

  return (
    <GeneralLayout>
      <StyledTitle>
        <div className="title">Campaigns</div>
      </StyledTitle>
      {campaigns.map((campaign, index) => (
        <StyledCard key={index}>
          <div className="title">{campaign}</div>
          <SecondaryButton
            label="Create New"
            size={ButtonSizeOptions.sm}
            onClick={() => setSelectedCampaign(campaign)}
          />
        </StyledCard>
      ))}

      {selectedCampaign && (
        <DripCampaignModal
          isOpen={Boolean(selectedCampaign)}
          title={`${selectedCampaign} ${templateShown ? "Template" : "Deal Selection"}`}
          onClose={() => {
            setSelectedCampaign(null);
            setTemplateShown(false);
            setSelectedDeal(null);
          }}
        >
          <StyledModalBody>
            {!templateShown && (
              <DealSelector onSelect={handleDealSelection} campaign={selectedCampaign} />
            )}
            {selectedDeal && !templateShown && (
              <>
                <div>
                  <StyledLabel>{selectedDeal.name}</StyledLabel>
                  <StyledLabel>{selectedDeal.type}</StyledLabel>
                </div>
                <StyledModalFooter>
                  <SecondaryButton
                    label="Create Template"
                    size={ButtonSizeOptions.smFluid}
                    onClick={() => setTemplateShown(true)}
                  />
                </StyledModalFooter>
              </>
            )}
            {templateShown && (
              <TemplateCreator dealName={selectedDeal.name} campaign={selectedCampaign} />
            )}
          </StyledModalBody>
        </DripCampaignModal>
      )}
    </GeneralLayout>
  );
};

export default Campaigns;
